// Predefined options for profile multi-selects

export const CORE_VALUES_OPTIONS = [
  // Personal Growth
  'Growth',
  'Learning',
  'Self-improvement',
  'Curiosity',
  'Knowledge',
  'Wisdom',

  // Relationships
  'Family',
  'Friendship',
  'Love',
  'Connection',
  'Community',
  'Empathy',
  'Compassion',

  // Achievement
  'Success',
  'Excellence',
  'Achievement',
  'Ambition',
  'Recognition',
  'Impact',
  'Legacy',

  // Freedom & Independence
  'Freedom',
  'Independence',
  'Autonomy',
  'Flexibility',
  'Adventure',
  'Exploration',

  // Creativity & Innovation
  'Creativity',
  'Innovation',
  'Originality',
  'Expression',
  'Imagination',

  // Integrity & Ethics
  'Integrity',
  'Honesty',
  'Authenticity',
  'Transparency',
  'Trust',
  'Loyalty',
  'Fairness',
  'Justice',

  // Health & Wellness
  'Health',
  'Wellness',
  'Balance',
  'Peace',
  'Harmony',
  'Mindfulness',

  // Service & Contribution
  'Service',
  'Contribution',
  'Generosity',
  'Kindness',
  'Helping others',
  'Making a difference',

  // Stability & Security
  'Stability',
  'Security',
  'Reliability',
  'Consistency',
  'Structure',

  // Fun & Enjoyment
  'Fun',
  'Joy',
  'Happiness',
  'Pleasure',
  'Humor',
  'Playfulness',

  // Other
  'Spirituality',
  'Faith',
  'Tradition',
  'Culture',
  'Diversity',
  'Sustainability',
  'Environment',
].sort();

export const INTERESTS_OPTIONS = [
  // Technology
  'Artificial Intelligence',
  'Machine Learning',
  'Programming',
  'Web Development',
  'Mobile Development',
  'Data Science',
  'Cybersecurity',
  'Blockchain',
  'Cloud Computing',
  'DevOps',
  'Gaming',
  'Virtual Reality',
  'Robotics',

  // Business & Finance
  'Entrepreneurship',
  'Startups',
  'Business Strategy',
  'Marketing',
  'Finance',
  'Investing',
  'Cryptocurrency',
  'Economics',
  'Real Estate',

  // Creative Arts
  'Art',
  'Design',
  'Photography',
  'Videography',
  'Music',
  'Writing',
  'Poetry',
  'Drawing',
  'Painting',
  'Sculpture',
  'Animation',
  'Film',
  'Theater',
  'Dance',

  // Science & Learning
  'Science',
  'Physics',
  'Chemistry',
  'Biology',
  'Astronomy',
  'Mathematics',
  'Psychology',
  'Philosophy',
  'History',
  'Literature',
  'Languages',

  // Sports & Fitness
  'Fitness',
  'Yoga',
  'Running',
  'Cycling',
  'Swimming',
  'Hiking',
  'Climbing',
  'Martial Arts',
  'Team Sports',
  'Individual Sports',

  // Lifestyle & Hobbies
  'Travel',
  'Cooking',
  'Baking',
  'Gardening',
  'Fashion',
  'Interior Design',
  'DIY Projects',
  'Crafts',
  'Reading',
  'Podcasts',
  'Meditation',
  'Mindfulness',

  // Social & Community
  'Volunteering',
  'Social Justice',
  'Activism',
  'Environmentalism',
  'Politics',
  'Community Building',
  'Teaching',
  'Mentoring',

  // Entertainment
  'Movies',
  'TV Shows',
  'Anime',
  'Comics',
  'Video Games',
  'Board Games',
  'Esports',

  // Nature & Outdoors
  'Nature',
  'Wildlife',
  'Camping',
  'Fishing',
  'Hunting',
  'Bird Watching',
  'Outdoor Photography',

  // Food & Drink
  'Food',
  'Wine',
  'Coffee',
  'Tea',
  'Craft Beer',
  'Fine Dining',
  'Street Food',

  // Music & Performance
  'Playing Instruments',
  'Singing',
  'DJing',
  'Music Production',
  'Concert Going',

  // Other
  'Pets',
  'Cars',
  'Motorcycles',
  'Aviation',
  'Sailing',
  'Astronomy',
  'Collecting',
  'Puzzles',
].sort();

export const SKILLS_OPTIONS = [
  // Programming Languages
  'JavaScript',
  'TypeScript',
  'Python',
  'Java',
  'C++',
  'C#',
  'Go',
  'Rust',
  'PHP',
  'Ruby',
  'Swift',
  'Kotlin',
  'R',
  'SQL',

  // Web Development
  'React',
  'Vue.js',
  'Angular',
  'Node.js',
  'Express.js',
  'Next.js',
  'HTML',
  'CSS',
  'Sass',
  'Tailwind CSS',
  'Bootstrap',

  // Mobile Development
  'React Native',
  'Flutter',
  'iOS Development',
  'Android Development',

  // Backend & Database
  'PostgreSQL',
  'MongoDB',
  'MySQL',
  'Redis',
  'GraphQL',
  'REST APIs',
  'Microservices',

  // Cloud & DevOps
  'AWS',
  'Azure',
  'Google Cloud',
  'Docker',
  'Kubernetes',
  'CI/CD',
  'Jenkins',
  'Git',
  'GitHub',
  'GitLab',

  // Data & AI
  'Machine Learning',
  'Deep Learning',
  'Data Analysis',
  'Data Visualization',
  'TensorFlow',
  'PyTorch',
  'Pandas',
  'NumPy',

  // Design
  'UI/UX Design',
  'Figma',
  'Adobe Photoshop',
  'Adobe Illustrator',
  'Sketch',
  'Graphic Design',
  '3D Modeling',

  // Business
  'Project Management',
  'Product Management',
  'Agile',
  'Scrum',
  'Leadership',
  'Communication',
  'Presentation',
  'Negotiation',
  'Sales',
  'Marketing',
  'SEO',
  'Content Writing',
  'Copywriting',

  // Other
  'Video Editing',
  'Photography',
  'Music Production',
  'Teaching',
  'Public Speaking',
  'Research',
  'Problem Solving',
  'Critical Thinking',
  'Time Management',
].sort();

export const LANGUAGES_OPTIONS = [
  'English',
  'Spanish',
  'Mandarin Chinese',
  'Hindi',
  'Arabic',
  'Portuguese',
  'Bengali',
  'Russian',
  'Japanese',
  'Punjabi',
  'German',
  'Javanese',
  'Wu Chinese',
  'Malay',
  'Telugu',
  'Vietnamese',
  'Korean',
  'French',
  'Marathi',
  'Tamil',
  'Urdu',
  'Turkish',
  'Italian',
  'Cantonese',
  'Thai',
  'Gujarati',
  'Jin Chinese',
  'Min Nan',
  'Persian',
  'Polish',
  'Pashto',
  'Kannada',
  'Xiang Chinese',
  'Malayalam',
  'Sundanese',
  'Hausa',
  'Odia',
  'Burmese',
  'Hakka Chinese',
  'Ukrainian',
  'Bhojpuri',
  'Tagalog',
  'Yoruba',
  'Maithili',
  'Uzbek',
  'Sindhi',
  'Amharic',
  'Fula',
  'Romanian',
  'Oromo',
  'Igbo',
  'Azerbaijani',
  'Awadhi',
  'Gan Chinese',
  'Cebuano',
  'Dutch',
  'Kurdish',
  'Serbo-Croatian',
  'Malagasy',
  'Saraiki',
  'Nepali',
  'Sinhala',
  'Chittagonian',
  'Zhuang',
  'Khmer',
  'Turkmen',
  'Assamese',
  'Madurese',
  'Somali',
  'Marwari',
  'Magahi',
  'Haryanvi',
  'Hungarian',
  'Chhattisgarhi',
  'Greek',
  'Chewa',
  'Deccan',
  'Akan',
  'Kazakh',
  'Min Bei',
  'Sylheti',
  'Zulu',
  'Czech',
  'Kinyarwanda',
  'Dhundhari',
  'Haitian Creole',
  'Min Dong',
  'Ilokano',
  'Quechua',
  'Kirundi',
  'Swedish',
  'Hmong',
  'Shona',
  'Uyghur',
  'Hiligaynon',
].sort();
